/**!
 * Created by Leonardo Cheslacki on 20/03/2024.
 *
 * MIT License
 *
 * Copyright (c) 2024 cheslacki
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

module.exports.scene = {
    layerActions: {
        /**
         * this.window = window;
         * const StageClass = window.StageClass;
         * StageClass.sun.scene.layerActions.frame01(this, 'current_name');
         * @param _this
         * @param current_name
         */
        frame01Game:  (_this, current_name) => {
            /**
             *
             *  @param object
             *  Set "this", object of canvas CreateJs.
             */
            AllTap.setState({...AllTap.state, [`_this_${current_name}`]: _this}, () => {

                const gamesIsland = AllTap.$gamesIsland({current_name: current_name});

                gamesIsland.initGame();
            });
        },
        /**
         * this.window = window;
         * const StageClass = window.StageClass;
         * StageClass.sun.scene.layerActions.frame01(this, 'current_name');
         * @param _this
         * @param current_name
         */
        frame01Activity:  (_this, current_name) => {
            /**
             *
             *  @param object
             *  Set "this", object of canvas CreateJs.
             */
            AllTap.setState({...AllTap.state, [`_this_${current_name}`]: _this}, () => {

                const gamesIsland = AllTap.$gamesIsland({current_name: current_name});

                gamesIsland.initActivity();
            });
        },
        /**
         * this.window = window;
         * const StageClass = window.StageClass;
         * StageClass.sun.scene.layerActions.frame01(this, 'current_name');
         * @param _this
         * @param current_name
         */
        frame01ActivityLevels:  (_this, current_name) => {
            /**
             *
             *  @param object
             *  Set "this", object of canvas CreateJs.
             */
            AllTap.setState({...AllTap.state, [`_this_${current_name}`]: _this}, () => {

                const gamesIsland = AllTap.$gamesIsland({current_name: current_name});

                gamesIsland.initActivityLevels();
            });
        },
        /**
         * this.window = window;
         * const StageClass = window.StageClass;
         * StageClass.sun.scene.layerActions.frame01Character(this, 'current_name', 'data_frames', 'parent_id', 'quiz_id');
         * @param _this
         * @param current_name
         * @param data_frames
         * @param parent_id
         * @param quiz_id
         */
        frame01Character: (_this, current_name, data_frames, parent_id, quiz_id) => {
            /**
             *
             *  @param object
             *  Set "this", object of canvas CreateJs.
             */
            AllTap.setState({...AllTap.state, [`_this_${current_name}`]: _this}, () => {
                const gamesCharacter = AllTap.$gamesCharacter({
                    current_name: current_name,
                    data_frames: data_frames,
                    parent_id: parent_id,
                    quiz_id: quiz_id
                });

                gamesCharacter.initCharacter();
            });
        },
        /**
         * this.window = window;
         * const StageClass = window.StageClass;
         * StageClass.sun.scene.layerActions.frame01Memory(this, 'current_name', 'data_frames', 'parent_id', 'quiz_id');
         * @param _this
         * @param current_name
         * @param data_frames
         * @param parent_id
         * @param quiz_id
         */
        frame01Memory: (_this, current_name, data_frames, parent_id, quiz_id) => {
            /**
             *
             *  @param object
             *  Set "this", object of canvas CreateJs.
             */
            AllTap.setState({...AllTap.state, [`_this_${current_name}`]: _this}, () => {
                const gamesMemory = AllTap.$gamesMemory({
                    current_name: current_name,
                    data_frames: data_frames,
                    parent_id: parent_id,
                    quiz_id: quiz_id
                });

                gamesMemory.initMemory();
            });
        }
    }
};
